// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Restaumatic_Menu_Promotions from "../Restaumatic.Menu.Promotions/index.js";
import * as Restaumatic_Menu_V2_Types_MenuCatalogue from "../Restaumatic.Menu.V2.Types.MenuCatalogue/index.js";
import * as Restaumatic_Promotions_Types from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
var decodeRawMenu = function (rawMenu) {
    var withId = function () {
        return function (x) {
            return new Data_Tuple.Tuple((Data_Newtype.unwrap()(x)).id, x);
        };
    };
    var fromRequired = function (msg) {
        return function (v) {
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Unscramble.decodingError(msg);
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.Decode (line 62, column 5 - line 64, column 37): " + [ v.constructor.name ]);
        };
    };
    var fromRawPrices = function (dictOrd) {
        return function (mkSize) {
            return function (prices) {
                var indexToSize = function (index) {
                    return function (price) {
                        return Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.Tuple.create(mkSize(index)))(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Newtype.unwrap())(price));
                    };
                };
                return Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(Data_Array.catMaybes(Data_Array.mapWithIndex(indexToSize)(prices)));
            };
        };
    };
    var promotions = Data_Map_Internal.fromFoldable(Restaumatic_Promotions_Types_Id.ordPromotionId)(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)((function () {
        var $9 = Unscramble.unsafeDecode(Restaumatic_Promotions_Types.unscrambleDecodePromotion);
        return function ($10) {
            return Restaumatic_Menu_Promotions.withPromotionId($9($10));
        };
    })())(rawMenu.promotions));
    return {
        promotions: promotions,
        timeZone: rawMenu.time_zone,
        enableCoupons: rawMenu.enable_coupons,
        enableFod: rawMenu.enable_fod,
        enableMarketingConsents: rawMenu.enable_marketing_consents,
        catalogue: rawMenu.catalogue,
        imagePrefix: Data_Maybe.fromMaybe("https://restaumatic.imgix.net")(rawMenu.image_prefix)
    };
};
var unsafeDecodeMenu = /* #__PURE__ */ (function () {
    var $11 = Unscramble.unsafeDecode(Unscramble.decodeRecord1()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "catalogue";
        }
    })(Restaumatic_Menu_V2_Types_MenuCatalogue.unscrambleDecodeMenuCatalogue)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "enable_coupons";
        }
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "enable_fod";
        }
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "enable_marketing_consents";
        }
    })(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "image_prefix";
        }
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "promotions";
        }
    })(Unscramble.decodeArray1(Unscramble.decodeForeign))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "time_zone";
        }
    })(Data_Time_Local.udecodeTZLabel)(Unscramble.decodeRecordNil)))))))));
    return function ($12) {
        return decodeRawMenu($11($12));
    };
})();
var decodeMenuEither = function (f) {
    return Unscramble.catchDecodingErrorEither(function (v) {
        return unsafeDecodeMenu(f);
    });
};
var decodeMenu = function (f) {
    var toExcept = function (v) {
        if (v instanceof Data_Either.Left) {
            return Foreign.fail(Data_Identity.monadIdentity)(new Foreign.ForeignError(v.value0));
        };
        if (v instanceof Data_Either.Right) {
            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(v.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.Decode (line 26, column 3 - line 26, column 52): " + [ v.constructor.name ]);
    };
    return toExcept(decodeMenuEither(f));
};
export {
    decodeMenu,
    decodeMenuEither,
    unsafeDecodeMenu,
    decodeRawMenu
};
//# sourceMappingURL=index.js.map
